<template>
  <div>
    <div class="breadcrumb">
      <span>社区管理</span>
      <span class="sep">/</span>
      <span>快捷评论</span>
    </div>

    <div class="content-wrapper">
      <!-- 搜索栏 -->
      <div class="filter-bar">
        <el-select
          v-model="queryParam.status"
          placeholder="状态"
          clearable
          style="width: 140px"
        >
          <el-option label="全部" :value="''"></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="停用" :value="0"></el-option>
        </el-select>
        <div>
          <el-button type="primary" @click="queryList">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </div>
      </div>

      <!-- 中部：新增 -->
      <div class="toolbar">
        <el-button type="primary" @click="openAdd">新增快捷评论</el-button>
      </div>

      <!-- 列表 -->
      <el-table
        :data="listData"
        v-loading="loading"
        border
        max-height="48vh"
        style="width: 100%"
      >
        <el-table-column label="序号" width="84" align="center">
          <template scope="scope">
            {{
              (queryParam.pageNum - 1) * queryParam.pageSize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="快捷评论" min-width="180">
          <template scope="{ row }">{{ row.content || "--" }}</template>
        </el-table-column>
        <el-table-column
          prop="sortNum"
          label="APP评论排序"
          width="130"
          align="center"
        >
          <template scope="{ row }">{{ row.sortNum }}</template>
        </el-table-column>
        <el-table-column
          prop="yesterdayUsageCount"
          label="昨日使用次数"
          width="120"
          align="right"
        >
          <template scope="{ row }">{{ row.yesterdayUsageCount }}</template>
        </el-table-column>
        <el-table-column
          prop="last30DaysUsageCount"
          label="近30天使用次数"
          width="140"
          align="right"
        >
          <template scope="{ row }">{{ row.last30DaysUsageCount }}</template>
        </el-table-column>
        <el-table-column
          prop="totalUsageCount"
          label="累计使用次数"
          width="120"
          align="right"
        >
          <template scope="{ row }">{{ row.totalUsageCount }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'gray'">
              {{ row.status === 1 ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="160">
          <template scope="{ row }">{{ row.createdAt || "--" }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" @click="toggleStatus(row)">
              {{ row.status === 1 ? "停用" : "启用" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager" v-if="totalCount > 0">
        <el-pagination
          @current-change="changeCurrentPage"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="totalCount"
          layout="total, prev, pager, next"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增 / 编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialog.visible"
      :modal-append-to-body="false"
      @close="closeDialog"
    >
      <el-form :model="form" label-width="90px">
        <el-form-item label="快捷评论" required>
          <div class="comment-input-wrap">
            <el-input
              v-model="form.content"
              placeholder="请输入内容，最多20个字"
              maxlength="20"
              style="width: 320px"
            ></el-input>
            <el-button
              class="emoji-btn"
              @click="showEmoji = !showEmoji"
              title="表情"
              >😊</el-button
            >
            <span class="word-tip">{{ form.content.length }}/20</span>
          </div>
          <div class="emoji-panel" v-if="showEmoji">
            <span
              v-for="(e, i) in emojiList"
              :key="i"
              class="emoji-item"
              @click="insertEmoji(e)"
              >{{ e }}</span
            >
          </div>
        </el-form-item>
        <el-form-item label="评论排序">
          <el-input-number
            v-model="form.sortNum"
            :min="1"
            :max="99"
            style="width: 160px"
          ></el-input-number>
          <span class="tip"
            >请输入数字，数字越小，排序越靠前<br />
            可输入数字1~99，不填或数字一致时，优先展示最近创建的快捷评论</span
          >
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 启用 / 停用二次确认 -->
    <el-dialog
      :title="confirmStatus.nextStatus === 1 ? '启用快捷评论' : '停用快捷评论'"
      :visible.sync="confirmStatus.visible"
      :modal-append-to-body="false"
      width="420px"
      @close="cancelToggle"
    >
      <p class="confirm-text">
        {{
          confirmStatus.nextStatus === 1
            ? "启用后，APP端将展示该快捷评论"
            : "停用后，APP端不展示该快捷评论，不影响已发布的评论"
        }}
      </p>
      <div slot="footer">
        <el-button @click="confirmStatus.visible = false">取消</el-button>
        <el-button
          :type="confirmStatus.nextStatus === 1 ? 'primary' : 'danger'"
          :loading="toggling"
          @click="confirmToggle"
          >{{ confirmStatus.nextStatus === 1 ? "启用" : "停用" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QuickComment",
  data() {
    return {
      queryParam: {
        status: "", // 1启用 0停用，空=全部
        pageNum: 1,
        pageSize: 10,
      },
      listData: [],
      totalCount: 0,
      loading: false,
      dialog: { visible: false, isEdit: false },
      form: { id: "", content: "", sortNum: null },
      showEmoji: false,
      submitting: false,
      // 启用/停用二次确认
      confirmStatus: { visible: false, row: null, nextStatus: 0 },
      toggling: false,
      // 表情面板：前端内置常见 emoji（如后端有表情接口，替换为接口数据）
      emojiList: [
        "😀",
        "😁",
        "😂",
        "🤣",
        "😊",
        "😍",
        "😘",
        "😎",
        "🤔",
        "😅",
        "😉",
        "😇",
        "🥰",
        "😜",
        "🤩",
        "🥳",
        "😏",
        "😴",
        "😭",
        "😡",
        "🤯",
        "😱",
        "🤗",
        "👍",
        "👏",
        "🙏",
        "💪",
        "🎉",
        "🎊",
        "🔥",
        "❤️",
        "💔",
        "✨",
        "⭐",
        "🌟",
        "💯",
        "🚀",
        "🌹",
        "💡",
        "📣",
        "🏃",
        "⚽",
        "🏀",
        "🎯",
        "🥇",
        "🌈",
        "☀️",
        "😺",
        "🐶",
        "🌸",
      ],
    };
  },
  computed: {
    dialogTitle() {
      return this.dialog.isEdit ? "编辑快捷评论" : "新增快捷评论";
    },
  },
  methods: {
    // 成功码：文档示例不一致（list 示例 error:0，add/updateStatus 示例 error:10000），兼容判断
    isOk(resp) {
      return resp && (resp.error === 10000 || resp.error === 0);
    },

    buildQueryBody() {
      const body = {
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      };
      if (this.queryParam.status !== "" && this.queryParam.status != null) {
        body.status = this.queryParam.status;
      }
      return body;
    },

    queryList() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/v70370/community/quickComment/list",
        method: "POST",
        body: JSON.stringify(this.buildQueryBody()),
      })
        .then((res) => {
          const resp = res.data || res.body;
          if (this.isOk(resp)) {
            const data = resp.data || {};
            this.listData = data.list || [];
            this.totalCount = data.totalCount || 0;
          } else {
            this.$util.errorMsg((resp && resp.message) || "查询失败");
            this.listData = [];
            this.totalCount = 0;
          }
        })
        .catch((err) => {
          this.$util.errorMsg((err && err.message) || "查询失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm() {
      this.queryParam = { status: "", pageNum: 1, pageSize: 20 };
      this.queryList();
    },

    changeCurrentPage(pageNum) {
      this.queryParam.pageNum = Number(pageNum) || 1;
      this.queryList();
    },

    openAdd() {
      this.dialog.isEdit = false;
      this.form = { id: "", content: "", sortNum: null };
      this.showEmoji = false;
      this.dialog.visible = true;
    },

    openEdit(row) {
      this.dialog.isEdit = true;
      this.form = {
        id: row.id,
        content: row.content || "",
        sortNum: row.sortNum == null ? null : row.sortNum,
      };
      this.showEmoji = false;
      this.dialog.visible = true;
    },

    closeDialog() {
      this.showEmoji = false;
      this.form = { id: "", content: "", sortNum: null };
    },

    insertEmoji(e) {
      if (this.form.content.length >= 20) {
        this.$util.errorMsg("快捷评论最多20个字");
        return;
      }
      this.form.content += e;
    },

    submit() {
      if (!this.form.content || !this.form.content.trim()) {
        this.$util.errorMsg("请输入快捷评论内容");
        return;
      }
      const payload = { content: this.form.content.trim() };
      if (this.form.sortNum != null && this.form.sortNum !== "") {
        payload.sortNum = this.form.sortNum;
      }
      if (this.dialog.isEdit) {
        payload.id = this.form.id;
      }
      const url = this.dialog.isEdit
        ? this.$util.domain + "/adminapi/v70370/community/quickComment/edit"
        : this.$util.domain + "/adminapi/v70370/community/quickComment/add";
      this.submitting = true;
      this.$http({
        url: url,
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const resp = res.data || res.body;
          if (this.isOk(resp)) {
            this.$util.successMsg(this.dialog.isEdit ? "编辑成功" : "创建成功");
            this.dialog.visible = false;
            this.queryList();
          } else {
            this.$util.errorMsg((resp && resp.message) || "保存失败");
          }
        })
        .catch((err) => {
          this.$util.errorMsg((err && err.message) || "保存失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    toggleStatus(row) {
      // 先打开二次确认框，不直接提交
      this.confirmStatus = {
        visible: true,
        row: row,
        nextStatus: row.status === 1 ? 0 : 1,
      };
    },

    cancelToggle() {
      this.confirmStatus = { visible: false, row: null, nextStatus: 0 };
    },

    confirmToggle() {
      const row = this.confirmStatus.row;
      const next = this.confirmStatus.nextStatus;
      if (!row) return;
      const label = next === 1 ? "启用" : "停用";
      this.toggling = true;
      this.$http({
        url:
          this.$util.domain +
          "/adminapi/v70370/community/quickComment/updateStatus",
        method: "POST",
        body: JSON.stringify({ id: row.id, status: next }),
      })
        .then((res) => {
          const resp = res.data || res.body;
          if (this.isOk(resp)) {
            this.$util.successMsg(label + "成功");
            this.confirmStatus.visible = false;
            this.queryList();
          } else {
            this.$util.errorMsg((resp && resp.message) || label + "失败");
          }
        })
        .catch((err) => {
          this.$util.errorMsg((err && err.message) || label + "失败");
        })
        .finally(() => {
          this.toggling = false;
        });
    },
  },
  mounted() {
    this.queryList();
  },
};
</script>

<style scoped>
.breadcrumb {
  padding: 12px 15px;
  font-size: 13px;
  color: #666;
}
.breadcrumb .sep {
  margin: 0 6px;
  color: #c0c4cc;
}
.content-wrapper {
  padding: 15px;
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.toolbar {
  margin: 24px 0;
}
.pager {
  margin-top: 12px;
  text-align: right;
}
.comment-input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.emoji-btn {
  padding: 6px 10px;
}
.word-tip {
  color: #c0c4cc;
  font-size: 12px;
}
.emoji-panel {
  margin-top: 8px;
  max-width: 360px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: 160px;
  overflow-y: auto;
}
.emoji-item {
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 4px;
}
.emoji-item:hover {
  background: #f5f7fa;
}
.tip {
  color: #c0c4cc;
  font-size: 12px;
  margin-left: 8px;
}
.confirm-text {
  margin: 0;
  padding: 4px 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// QuickComment.vue?94076a2e